module.exports = { "default": require("core-js/library/fn/object/seal"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/seal.js
// module id = 8YIr
// module chunks = 3